export const LIBRARY_SETTINGS_PATH = 'landing/library/settings';
export const J1QL_AUTOCOMPLETE_PATH = 'j1ql/autocomplete';

export enum LandingRouteNames {
  ROOT = 'ROOT',
  VISUAL_QUERY_BUILDER = 'VISUAL_QUERY_BUILDER',
}

type Routes = {
  [key in LandingRouteNames]: {
    url: string;
    title: string;
  };
};

export const LANDING_ROUTES: Routes = {
  [LandingRouteNames.ROOT]: {
    url: '',
    title: 'Landing',
  },
  [LandingRouteNames.VISUAL_QUERY_BUILDER]: {
    url: '/visualquery',
    title: 'J1QL Visual Query Builder',
  },
};
